/**
 * given an object travel its keys to the path requested and return the value there
 * @param {string} path the path to the key desired in the object using periods to search deeper and commas to get a truthy value on multiple paths
 * @param {Object} obj the object to get a property value from
 * @example 
 *  path: "data.id,data.valid",
 *  obj: {data: {id: 123, valid: true}} => true
 * @example
 *  path: "data.id",
 *  obj: {data: {id: 123}} => 123
 * @example
 *  path: "badPath", 
 *  obj: {data: {id: 123}} => false
 */
const getPathValue = (path, obj) => {
  // if the path has multiple return a boolean for if each are true
  // ex: "event.read,event.create"
  if (path.split(',').length > 1) {
    return path.split(',').every(aPath => getPathValue(aPath, obj))
  }
  const keys = path.split('.')
  let value
  for (let i = 0; i < keys.length; i++) {
    const nextKey = keys[i]
    if (value === undefined) {
      if (value === undefined && i !== 0) {
        break
      }
      value = obj[nextKey]
    } else {
      value = value[nextKey]
    }
  }
  if (!value) {
    return false
  } else {
    return value
  }
}

export default getPathValue
